import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { IonContent } from '@ionic/angular';
import { SurveyAnswer, SurveyHeader, SurveyResult } from 'src/app/models/survey-header.model';
import { AuthService } from 'src/app/services/auth.service';
import { DataService } from 'src/app/services/data.service';
import { SurveyService } from 'src/app/services/survey.service';


@Component({
  selector: 'app-survey-detail',
  templateUrl: './survey-detail.component.html',
  styleUrls: ['./survey-detail.component.scss'],
})
export class SurveyDetailComponent implements OnInit {
  
  @ViewChild(IonContent, {static: false}) content: IonContent;



  survey: SurveyHeader;
  surveyNotes: string;
  displayContent: boolean[] = [];

  optionAnswers: string[] = [];

  optionStatus = '';
  constructor(
    private actvRoute: ActivatedRoute,
    private surveyServ: SurveyService,
    public authServ: AuthService,
    private router: Router,
    public dataServ: DataService
  ) { }

  async ngOnInit() {

    window.addEventListener('ionKeyboardDidHide', (e) => {
      this.content.scrollToBottom(400);
    });

    if (!this.authServ.isLogged) {
      this.router.navigateByUrl('/profile');
    }
    try {

      await this.authServ.getMe();

      this.surveyServ.surveyForm.name = this.authServ.profile.first_name;
      this.surveyServ.surveyForm.surname = this.authServ.profile.last_name;
      this.surveyServ.surveyForm.room_no = this.authServ.profile.room_no;
      this.surveyServ.surveyForm.email = this.authServ.profile.e_mail;
      this.surveyServ.surveyForm.phone_no = this.authServ.profile.phone_no;

    } catch (error) {
      console.log("error", error);
    }

    const ID = this.actvRoute.snapshot.params.id;
    this.survey = await this.surveyServ.getSurvey(ID);
  }

  async submitSurvey() {
    const SURVEYANSWERS: SurveyAnswer[] = this.survey.groups.reduce((acc: SurveyAnswer[], group) => {

      const ANSWERS: SurveyAnswer[] = group.survey_lines.map(line => {
        const ANSWER = new SurveyAnswer(line, this.authServ.profile.id, (this.surveyServ.surveyForm.name + ' ' + this.surveyServ.surveyForm.surname),
          this.surveyServ.surveyForm.room_no, this.surveyServ.surveyForm.phone_no, this.surveyServ.surveyForm.email);
        return ANSWER;
      });

      return acc.concat(ANSWERS);
    }, []);

    const RESULT = new SurveyResult();
    RESULT.survey_answers = SURVEYANSWERS;
    RESULT.note = this.surveyNotes;

    try {
      const RESP = await this.surveyServ.submitSurvey(RESULT);
      if (RESP.survey_result >= 7) {
        this.router.navigate(['positive-feedback-survey'], { relativeTo: this.actvRoute });

      }
      else {
        this.router.navigate(['negative-feedback-survey'], { relativeTo: this.actvRoute });
      }
    } catch (error) {

    }

  }

  accordionSwitch(index: number) {
    this.displayContent[index] = !Boolean(this.displayContent[index]);
  }

}
